import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock, TrendingUp, TrendingDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function RecentTransactionsWidget({ recentTransactions = [], cardClass = '' }) {
  const navigate = useNavigate();

  return (
    <Card className={`${cardClass} overflow-hidden`} data-testid="widget-recent-transactions">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <CardTitle className="font-outfit text-base flex items-center gap-2">
            <Clock size={16} className="text-info" />
            Recent Transactions
          </CardTitle>
          <Button size="sm" variant="ghost" className="text-xs" onClick={() => navigate('/sales')}>View All</Button>
        </div>
      </CardHeader>
      <CardContent>
        {recentTransactions.length === 0 ? (
          <div className="text-center py-6 text-muted-foreground text-sm">
            <Clock size={24} className="mx-auto mb-2 opacity-40" />
            <p>No recent transactions</p>
          </div>
        ) : (
          <div className="space-y-1.5">
            {recentTransactions.slice(0, 6).map((tx, i) => (
              <div key={i} className="flex items-center justify-between py-2 px-2.5 rounded-lg hover:bg-muted/50 transition-colors text-sm">
                <div className="flex items-center gap-2.5 min-w-0">
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${
                    tx.txType === 'sale' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'
                  }`}>
                    {tx.txType === 'sale' ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
                  </div>
                  <div className="min-w-0">
                    <p className="font-medium text-foreground text-xs truncate">{tx.customer_name || tx.category || tx.txType === 'sale' ? 'Sale' : 'Expense'}</p>
                    <p className="text-[10px] text-muted-foreground">{tx.date ? new Date(tx.date).toLocaleDateString() : ''}</p>
                  </div>
                </div>
                <span className={`font-bold text-xs ${tx.txType === 'sale' ? 'text-success' : 'text-error'}`}>
                  {tx.txType === 'sale' ? '+' : '-'}{(tx.total || tx.amount || 0).toLocaleString()}
                </span>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
